import React from "react";
import { Col, Row } from "react-bootstrap";

const Terms = () => {
  const darkModeStyles = {
    container: {
      backgroundColor: "#121212",
      color: "#ffffff",
      padding: "2rem",
      borderRadius: "5px",
      textAlign: "justify",
      lineHeight: "1.6",
    },
    header: {
      fontSize: "23px",
      textAlign: "center",
      margin: "1.5rem 0",
    },
    sectionHeader: {
      fontSize: "23px",
      margin: "1.5rem 0 1rem",
      fontWeight: "bold",
    },
    paragraph: {
      marginBottom: "1rem",
      textAlign: "justify",
    },
    list: {
      paddingLeft: "1.5rem",
      marginBottom: "1rem",
    },
    listItem: {
      marginBottom: "0.5rem",
    },
  };

  return (
    <div className="container my-4">
      <div className="d-flex flex-column justify-content-center align-items-center auth px-0 w-100">
        <Row className="w-100 mx-0">
          <Col lg={12} md={12} sm={12} className="mx-auto">
            <div
              className="auth-form-light text-left py-5 px-4 px-sm-5"
              style={darkModeStyles.container}
            >
              <div className="brand-logo d-flex">
                <img
                  className="mx-auto"
                  src={require("../../../../assets/images/logo.png")}
                  alt="logo"
                // style={darkModeStyles.logo}
                />
              </div>
              <p style={darkModeStyles.header}>
                <b>
                  <center>TERMS AND CONDITIONS</center>
                </b>
              </p>
              <p style={darkModeStyles.sectionHeader}>
                <b>Overview</b>
              </p>
              <p>
                These terms and conditions outline the rules and regulations for the use of SK8 GYM’s App. SK8 GYM is headquartered in: Martinez, CA – 94553, United States
              </p>
              <p>
                By accessing this app we assume you accept these terms and conditions in full. Do not continue to use SK8 GYM’s app
                if you do not accept all of the terms and conditions stated on this page.
              </p>
              <p>
                The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice
                and any or all Agreements: “Client," “You” and “Your” refers to you, the person accessing this app
                and accepting the Company’s terms and conditions.
              </p>
              <p>
                “The Company," “Ourselves," “We," “Our” and “Us”, refers
                to our Company. “Party," “Parties," or “Us," refers to both the Client and ourselves, or either the Client
                or ourselves.
              </p>
              <p>
                All terms refer to the offer, acceptance and consideration of payment necessary to undertake
                the process of our assistance to the Client in the most appropriate manner, whether by formal meetings of a fixed duration, or any other means, for the express purpose of meeting the client’s needs in respect of provision of the company’s stated services/ products, in accordance with and subject to, prevailing law of United States. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.
              </p>

              <p style={darkModeStyles.sectionHeader}>
                <b>Information & collection use</b>
              </p>
              <p>
                We employ the use of cookies. By using SK8 GYM’s app you consent to the use of cookies in accordance with SK8 GYM’s privacy policy. Most of the modern day interactive app use cookies to enable us to retrieve user details for each visit.
              </p>
              <p>
                We employ the use of cookies. By using SK8 GYM’s app you consent to the use of cookies in accordance with SK8 GYM’s privacy policy. Most of the modern day interactive app use cookies to enable us to retrieve user details for each visit.
              </p>
              <p>
                Some of our affiliate / advertising partners may also use cookies.
              </p>

              <p>
                <br />
                <p style={darkModeStyles.sectionHeader}>
                  <b>Cookies</b>
                </p>
                <li> Personal Data:</li>
                <p>
                  While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (“Personal Data”). Personally identifiable information may include, but is not limited to: Email address, first name and last name, Phone number, address, City, State, Province, ZIP/Postal code.
                </p>
                <br />
                <li> Usage Data:</li>
                <p>
                  We may also collect information how the Service is accessed and used (“Usage Data”). This Usage Data may include information such as your computer’s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
                </p>
                <br />
                <li> Tracking & Cookies Data:</li>
                <p>
                  We use cookies and similar tracking technologies to track the activity on our Service and hold certain information. Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a app and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
                </p>
                <p>
                  Examples of Cookies we use: Session Cookies. We use Session Cookies to operate our Service. Preference Cookies. We use Preference Cookies to remember your preferences and various settings. Security Cookies. We use Security Cookies for security purposes.
                </p>
                <br />
              </p>

              <p>
                <p style={darkModeStyles.sectionHeader}>
                  <b>License</b>
                </p>
                <p>
                  Unless otherwise stated, SK8 GYM and/ or it’s licensors own the intellectual property rights for all material on SK8 GYM. All intellectual property rights are reserved. You may view and/or print pages from http://sk8gym.com for your own personal use subject to restrictions set in these terms and conditions. You must not:,
                  <ol>
                    <li>Republish material from http://sk8gym.com</li>
                    <li>Sell, rent or sub-license material from http://sk8gym.com</li>
                    <li>Duplicate or copy material from http://sk8gym.com</li>
                    <li>Redistribute content from SK8 GYM (unless content is specifically made for redistribution).</li>
                  </ol>
                </p>
                <br />
              </p>

              <p>
                <p style={darkModeStyles.sectionHeader}>
                  <b>Hyperlinking to our content</b>
                </p>
                <p>
                  The following organizations may link to our app without prior written approval: Government agencies;
                  Search engines; News organizations Online directory distributors when they list us in the directory may link to our app
                  in the same manner as they hyperlink to the apps of other listed businesses;
                  and Systemwide.
                </p>
                <p>
                  Accredited Businesses except soliciting non-profit organizations, charity shopping
                  malls, and charity fundraising groups which may not hyperlink to our app.
                  These organizations may link to our home page, to publications or to other app information so
                  long as the link: (a) is not in any way misleading; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the context of the linking party’s site.
                </p>
                <p>
                  We may consider and approve in our sole discretion other link requests from the following types of organizations: commonly-known consumer and/or business information sources such as Chambers of Commerce,
                  American Automobile Association, AARP and Consumers Union; dot.com community sites;
                  associations or other groups representing charities, including charity giving sites,
                  online directory distributors; internet portals; accounting, law and consulting firms
                  whose primary clients are businesses; and educational institutions and trade associations.
                  We will approve link requests from these organizations if we determine that: (a) the link would not reflect unfavorably
                  on us or our accredited businesses (for example, trade associations or other organizations
                  representing inherently suspect types of business, such as work-at-home opportunities,
                  shall not be allowed to link); (b) the organization does not have an unsatisfactory
                  record with us; (c) the benefit to us from the visibility associated with the hyperlink outweighs the absence of link is in the context of general
                  resource information or is otherwise consistent with editorial content in a newsletter or similar product furthering the mission of the organization.These organizations may link to our home page, to publications or to other app information so long as
                  the link: (a) is not in any way misleading; (b) does not falsely imply sponsorship,
                  endorsement or approval of the linking party and it products or services; and (c) fits
                  within the context of the linking party’s site. If you are among the organizations listed in paragraph 2 above and are interested in
                  linking to our app, you must notify us by sending an e-mail to info@sk8gym.com.
                </p>
                <p>
                  Please include your name, your organization name, contact information (such as a phone number and/or e-mail address) as well as the URL of your site, a list of any URLs from which you intend to link to our app, and a list of the URL(s) on our site to which you would like to link.
                  Allow 2-3 weeks for a response
                </p>
                <p>
                  Approved organizations may hyperlink to our app as follows:
                  <ol>
                    <li>By use of our corporate name; or</li>
                    <li>By use of the uniform resource locator (app) being linked to; or</li>
                    <li>By use of any other description of our app or material being linked to that makes sense within the context and format of content on the linking party’s site.</li>
                  </ol>
                </p>
                <p>
                  No use of SK8 GYM’s logo or other artwork will be allowed for linking absent a trademark license agreement.
                </p>
                <br />
              </p>


              <p>
                <p style={darkModeStyles.sectionHeader}>
                  <b>IFRAMES</b>
                </p>
                <p>
                  Without prior approval and express written permission, you may not create frames around our app pages or see other techniques that alter in anyway the visual presentation or appearance of our app.
                </p>
                <br />
              </p>

              <p>
                <p style={darkModeStyles.sectionHeader}>
                  <b>Reservation of Rights</b>
                </p>
                <p>
                  If you find any link on our app or any linked app objectionable for any reason, you may contact us about it. We will consider requests to remove links but will have no obligation to do so or to respond directly to you.
                </p>
                <p>
                  While we endeavour to ensure that the information on this app is correct, we do not warrant its completeness or accuracy; nor do we commit to ensuring that the app remains available or that the material on the app is kept up to date.
                </p>
                <br />
              </p>

              <p>
                <p style={darkModeStyles.sectionHeader}>
                  <b>Removal of links from our app</b>
                </p>
                <p>
                  If you find any link on our app or any linked app objectionable for any reason, you may contact us about this. We will consider requests to remove links but will have no obligation to do so or to respond directly to you. While we endeavour to ensure that the information on this app is correct, we do not warrant its completeness or accuracy; nor do we commit
                  to ensuring that the app remains available or that the material on the app is kept up to date.
                </p>
                <br />
              </p>

              <p>
                <p style={darkModeStyles.sectionHeader}>
                  <b>Information and collection use</b>
                </p>
                <p>
                  We shall have no responsibility or liability for any content appearing on your app.
                  You agree to indemnify and defend us against all claims arising out of or based upon your app.
                  No link(s) may appear on any page on your app or within any context containing content or materials that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.
                </p>
                <br />
              </p>

              <p>
                <p style={darkModeStyles.sectionHeader}>
                  <b>Links to other sites</b>
                </p>
                <p>
                  To the maximum extent permitted by applicable law, we exclude all representations,
                  warranties and conditions relating to our app and the use of this app
                  (including, without limitation, any warranties implied by law in respect of satisfactory quality,
                  fitness for purpose and/or the use of reasonable care and skill).
                </p>
                <p>
                  Nothing in this disclaimer will:
                  <ol>
                    <li>Limit or exclude our or your liability for death or personal injury resulting from negligence;</li>
                    <li>Limit or exclude our or your liability for fraud or fraudulent misrepresentation;</li>
                    <li>Limit any of our or your liabilities in any way that is not permitted under applicable law; or</li>
                    <li>Exclude any of our or your liabilities that may not be excluded under applicable law.</li>
                  </ol>
                </p>
                <p>
                  The limitations and exclusions of liability set out in this Section and elsewhere
                  in this disclaimer:
                  (a) are subject to the preceding paragraph; and
                  (b) govern all liabilities arising under the disclaimer
                  or in relation to the subject matter of this disclaimer, including liabilities
                  arising in contract,
                  in tort (including negligence) and for breach of statutory duty.
                </p>
                <p>
                  To the extent that the app and the information and services on the app are provided free of charge, we will not be liable for any loss or damage of any nature.
                </p>
                <br />
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Terms;
